import React from 'react';
import { HiOutlineExclamationCircle } from 'react-icons/hi';
import { Link, Text, Box, Icon, Flex } from '@chakra-ui/react';
import { Tag } from 'components';

interface ContractText {
  title: string;
  text: string;
  type?: 'link' | 'status' | 'text';
  isNormal?: boolean;
}

export const ContractText: React.FC<ContractText> = ({
  title,
  text,
  type = 'text',
  isNormal = false,
}) => {
  return (
    <Box>
      <Text fontWeight={isNormal ? 400 : 700} textColor="button">
        {title}
      </Text>
      {type === 'link' ? (
        <Flex alignItems="center">
          <Link
            textDecor="underline"
            href="https://vamos.com.br/locacao/nossos-planos"
            textColor="text.100"
            color="blue.0"
          >
            {text}
          </Link>
          <Icon ml="4px" color="black" as={HiOutlineExclamationCircle} />
        </Flex>
      ) : type === 'status' ? (
        <Tag label={text} />
      ) : (
        <Text textColor="text.100">{text}</Text>
      )}
    </Box>
  );
};
